var s = (a, e, l) => new Promise((n, o) => {
  var t = (h) => {
    try {
      i(l.next(h));
    } catch (r) {
      o(r);
    }
  }, m = (h) => {
    try {
      i(l.throw(h));
    } catch (r) {
      o(r);
    }
  }, i = (h) => h.done ? n(h.value) : Promise.resolve(h.value).then(t, m);
  i((l = l.apply(a, e)).next());
});
import { A as c, R as p } from "./colors-cfab1b7b.js";
import { a as na, g as oa, C as ha, d as ca, c as ia, h as ra, D as sa, E as pa, f as da, F as ta, I as ma, M as ba, N as ua, b as Aa, P as Ea, e as Sa, k as Ta, S as Ra, j as ga, i as _a, T as Na, W as Ia, s as La, p as Oa, q as Ca, m as Ma, l as Pa, n as ka, o as Ga, r as Da, u as Ba, t as Ua } from "./colors-cfab1b7b.js";
import { c as fa, f as ya, p as Ka, s as wa, u as Ha } from "./formatDescription-d621e46d.js";
import { b as za, c as Wa, g as xa, d as Ya, h as ja, i as Va, a as Za } from "./avod-d6b845d4.js";
var b = /* @__PURE__ */ ((a) => (a.NAME = "name", a.SURNAME = "surname", a))(b || {}), u = /* @__PURE__ */ ((a) => (a.LINE_1 = "line1", a.LINE_2 = "line2", a.CITY = "city", a.STATE = "state", a.POSTAL_CODE = "postalCode", a.COUNTRY = "country", a))(u || {}), A = /* @__PURE__ */ ((a) => (a.jumbotron = "jumbotron", a.thumbnail = "thumbnail", a.child = "child", a.logo = "logo", a.logoCentred = "logoCentred", a.portrait = "portrait", a.square = "square", a.skyscraperWithLogo = "skyscraperWithLogo", a.billboard = "billboard", a.backgroundCentred = "backgroundCentred", a.featureBannerHD = "featureBannerHD", a.squareLogo = "squareLogo", a.rectangle43Logo = "rectangle43Logo", a))(A || {}), E = /* @__PURE__ */ ((a) => (a.MPD = "application/dash+xml", a.M3U8 = "application/x-mpegURL", a))(E || {}), S = /* @__PURE__ */ ((a) => (a.CHROMECAST = "CHROMECAST", a.AIRPLAY = "AIRPLAY", a))(S || {}), T = /* @__PURE__ */ ((a) => (a.FACEBOOK = "FACEBOOK", a.TWITTER = "TWITTER", a.GOOGLE = "GOOGLE", a.APPLE = "APPLE", a.EMAIL_PASSWORD = "EMAIL_PASSWORD", a.PHONE_NUMBER = "PHONE_NUMBER", a.TIMES_SSO = "TIMES_SSO", a))(T || {}), R = /* @__PURE__ */ ((a) => (a.NATIVE = "NATIVE", a.ATTRIBUTED_CHECKOUT = "ATTRIBUTED_CHECKOUT", a))(R || {}), g = /* @__PURE__ */ ((a) => (a.STARTED = "STARTED", a.PROGRESSED = "PROGRESSED", a.CLOSED = "CLOSED", a.FINISHED = "FINISHED", a.NEXT_INITIALIZED = "NEXT_INITIALIZED", a))(g || {});
const H = "stream/limit-exceeded";
var _ = /* @__PURE__ */ ((a) => (a.BILLBOARD = "BILLBOARD", a.CAROUSEL = "CAROUSEL", a.CONTINUE_WATCHING = "CONTINUE_WATCHING", a.JUMBOTRON = "JUMBOTRON", a.LANDSCAPE_CAROUSEL = "LANDSCAPE_CAROUSEL", a.LARGE_PORTRAIT_CAROUSEL = "LARGE_PORTRAIT_CAROUSEL", a.PORTRAIT_CAROUSEL = "PORTRAIT_CAROUSEL", a.PORTRAIT_EXPANDABLE_CAROUSEL = "PORTRAIT_EXPANDABLE_CAROUSEL", a.RECOMMENDATION = "RECOMMENDATION", a.SKYSCRAPER_CAROUSEL = "SKYSCRAPER_CAROUSEL", a.SQUARE_CAROUSEL = "SQUARE_CAROUSEL", a.FEATURED_ASSET = "FEATURED_ASSET", a))(_ || {}), N = /* @__PURE__ */ ((a) => (a.PLAN = "PLAN", a))(N || {}), I = /* @__PURE__ */ ((a) => (a.ASSET_NOT_AVAILABLE_IN_USER_PLAN = "asset_access_forbidden/asset_not_available_in_user_plan", a.ASSET_NOT_AVAILABLE_IN_USER_REGION = "asset_access_forbidden/asset_not_available_in_user_region", a.PLAN_NOT_AVAILABLE_IN_USER_REGION = "asset_access_forbidden/plan_not_available_in_user_region", a.PLAN_NOT_AVAILABLE_FOR_USER_PLATFORM = "asset_access_forbidden/plan_not_available_for_user_platform", a.USER_AGE_RESTRICTION_EXCEEDED = "asset_access_forbidden/user_age_restriction_exceeded", a.USER_ACCESS_TO_PLAN_EXPIRED = "asset_access_forbidden/user_access_to_plan_expired", a.USER_UNREGISTERED = "asset_access_forbidden/user_unregistered", a.USER_HAS_NO_PLAN = "asset_access_forbidden/user_has_no_plan", a))(I || {}), L = /* @__PURE__ */ ((a) => (a.STREAM_CONCURRENCY_ERROR_CODE = "stream/limit-exceeded", a))(L || {});
const O = (a) => new Promise((e) => {
  setTimeout(() => e(), a);
}), F = (a, e = 3) => s(void 0, null, function* () {
  let l;
  for (let n = 0; n < e; n++)
    try {
      return yield a();
    } catch (o) {
      l = o, yield O((n + 1) * 1e3);
    }
  throw l;
}), z = "#F6D917", W = ["p", "strong", "em", "u", "a"], x = ["href", "rel", "target"], Y = (a) => {
  if (!a)
    return d[0];
  const e = a.length >= 2 ? [a.charAt(0), a.charAt(1)] : [a, a], l = e[0].charCodeAt(0) * e[1].charCodeAt(0) % 10;
  return d[l];
}, j = (a) => a ? a.charAt(0) + a.charAt(1) : "DE", d = [
  "#a60000",
  "#e06500",
  "#0061a6",
  "#00a685",
  "#a60059",
  "#7b00e0",
  "#3200a6",
  "#859900",
  "#d4c900",
  "#1ca600"
], C = (a) => {
  switch (a) {
    case c.MOVIE:
      return k;
    case c.LIVE_CHANNEL:
    case c.LIVE_EVENT:
      return D;
    case c.EPISODE:
    case c.SEASON:
    case c.SHOW:
      return G;
    default:
      return B;
  }
}, V = ({
  id: a,
  type: e,
  administrativeName: l
}) => {
  var o;
  return C(e).replace(":name", (o = M(l)) != null ? o : "").replace(":id", a);
}, M = (a) => {
  if (a)
    return a.replace(P, "-").toLowerCase();
}, P = /[^a-zA-Z0-9]+/g, k = "/movie/:name/:id", G = "/tv-show/:name/:id", D = "/live/:name/:id", B = "/:id", U = [429], Z = (a) => {
  if (a)
    return a >= 400 && a < 500 && !U.includes(a);
}, J = (a, e) => Math.min(
  Math.max.apply(null, [
    ...(a || []).map((n) => Number(n)),
    p.SD540
  ]),
  e || p.UHD
), v = [
  { name: "Afghanistan", code: "AF" },
  { name: "Åland Islands", code: "AX" },
  { name: "Albania", code: "AL" },
  { name: "Algeria", code: "DZ" },
  { name: "American Samoa", code: "AS" },
  { name: "AndorrA", code: "AD" },
  { name: "Angola", code: "AO" },
  { name: "Anguilla", code: "AI" },
  { name: "Antarctica", code: "AQ" },
  { name: "Antigua and Barbuda", code: "AG" },
  { name: "Argentina", code: "AR" },
  { name: "Armenia", code: "AM" },
  { name: "Aruba", code: "AW" },
  { name: "Australia", code: "AU" },
  { name: "Austria", code: "AT" },
  { name: "Azerbaijan", code: "AZ" },
  { name: "Bahamas", code: "BS" },
  { name: "Bahrain", code: "BH" },
  { name: "Bangladesh", code: "BD" },
  { name: "Barbados", code: "BB" },
  { name: "Belarus", code: "BY" },
  { name: "Belgium", code: "BE" },
  { name: "Belize", code: "BZ" },
  { name: "Benin", code: "BJ" },
  { name: "Bermuda", code: "BM" },
  { name: "Bhutan", code: "BT" },
  { name: "Bolivia", code: "BO" },
  { name: "Bosnia and Herzegovina", code: "BA" },
  { name: "Botswana", code: "BW" },
  { name: "Bouvet Island", code: "BV" },
  { name: "Brazil", code: "BR" },
  { name: "British Indian Ocean Territory", code: "IO" },
  { name: "Brunei Darussalam", code: "BN" },
  { name: "Bulgaria", code: "BG" },
  { name: "Burkina Faso", code: "BF" },
  { name: "Burundi", code: "BI" },
  { name: "Cambodia", code: "KH" },
  { name: "Cameroon", code: "CM" },
  { name: "Canada", code: "CA" },
  { name: "Cape Verde", code: "CV" },
  { name: "Cayman Islands", code: "KY" },
  { name: "Central African Republic", code: "CF" },
  { name: "Chad", code: "TD" },
  { name: "Chile", code: "CL" },
  { name: "China", code: "CN" },
  { name: "Christmas Island", code: "CX" },
  { name: "Cocos (Keeling) Islands", code: "CC" },
  { name: "Colombia", code: "CO" },
  { name: "Comoros", code: "KM" },
  { name: "Congo", code: "CG" },
  { name: "Congo, The Democratic Republic of the", code: "CD" },
  { name: "Cook Islands", code: "CK" },
  { name: "Costa Rica", code: "CR" },
  { name: 'Cote D"Ivoire', code: "CI" },
  { name: "Croatia", code: "HR" },
  { name: "Cuba", code: "CU" },
  { name: "Cyprus", code: "CY" },
  { name: "Czech Republic", code: "CZ" },
  { name: "Denmark", code: "DK" },
  { name: "Djibouti", code: "DJ" },
  { name: "Dominica", code: "DM" },
  { name: "Dominican Republic", code: "DO" },
  { name: "Ecuador", code: "EC" },
  { name: "Egypt", code: "EG" },
  { name: "El Salvador", code: "SV" },
  { name: "Equatorial Guinea", code: "GQ" },
  { name: "Eritrea", code: "ER" },
  { name: "Estonia", code: "EE" },
  { name: "Ethiopia", code: "ET" },
  { name: "Falkland Islands (Malvinas)", code: "FK" },
  { name: "Faroe Islands", code: "FO" },
  { name: "Fiji", code: "FJ" },
  { name: "Finland", code: "FI" },
  { name: "France", code: "FR" },
  { name: "French Guiana", code: "GF" },
  { name: "French Polynesia", code: "PF" },
  { name: "French Southern Territories", code: "TF" },
  { name: "Gabon", code: "GA" },
  { name: "Gambia", code: "GM" },
  { name: "Georgia", code: "GE" },
  { name: "Germany", code: "DE" },
  { name: "Ghana", code: "GH" },
  { name: "Gibraltar", code: "GI" },
  { name: "Greece", code: "GR" },
  { name: "Greenland", code: "GL" },
  { name: "Grenada", code: "GD" },
  { name: "Guadeloupe", code: "GP" },
  { name: "Guam", code: "GU" },
  { name: "Guatemala", code: "GT" },
  { name: "Guernsey", code: "GG" },
  { name: "Guinea", code: "GN" },
  { name: "Guinea-Bissau", code: "GW" },
  { name: "Guyana", code: "GY" },
  { name: "Haiti", code: "HT" },
  { name: "Heard Island and Mcdonald Islands", code: "HM" },
  { name: "Holy See (Vatican City State)", code: "VA" },
  { name: "Honduras", code: "HN" },
  { name: "Hong Kong", code: "HK" },
  { name: "Hungary", code: "HU" },
  { name: "Iceland", code: "IS" },
  { name: "India", code: "IN" },
  { name: "Indonesia", code: "ID" },
  { name: "Iran, Islamic Republic Of", code: "IR" },
  { name: "Iraq", code: "IQ" },
  { name: "Ireland", code: "IE" },
  { name: "Isle of Man", code: "IM" },
  { name: "Israel", code: "IL" },
  { name: "Italy", code: "IT" },
  { name: "Jamaica", code: "JM" },
  { name: "Japan", code: "JP" },
  { name: "Jersey", code: "JE" },
  { name: "Jordan", code: "JO" },
  { name: "Kazakhstan", code: "KZ" },
  { name: "Kenya", code: "KE" },
  { name: "Kiribati", code: "KI" },
  { name: 'Korea, Democratic People"S Republic of', code: "KP" },
  { name: "Korea, Republic of", code: "KR" },
  { name: "Kuwait", code: "KW" },
  { name: "Kyrgyzstan", code: "KG" },
  { name: 'Lao People"S Democratic Republic', code: "LA" },
  { name: "Latvia", code: "LV" },
  { name: "Lebanon", code: "LB" },
  { name: "Lesotho", code: "LS" },
  { name: "Liberia", code: "LR" },
  { name: "Libyan Arab Jamahiriya", code: "LY" },
  { name: "Liechtenstein", code: "LI" },
  { name: "Lithuania", code: "LT" },
  { name: "Luxembourg", code: "LU" },
  { name: "Macao", code: "MO" },
  { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
  { name: "Madagascar", code: "MG" },
  { name: "Malawi", code: "MW" },
  { name: "Malaysia", code: "MY" },
  { name: "Maldives", code: "MV" },
  { name: "Mali", code: "ML" },
  { name: "Malta", code: "MT" },
  { name: "Marshall Islands", code: "MH" },
  { name: "Martinique", code: "MQ" },
  { name: "Mauritania", code: "MR" },
  { name: "Mauritius", code: "MU" },
  { name: "Mayotte", code: "YT" },
  { name: "Mexico", code: "MX" },
  { name: "Micronesia, Federated States of", code: "FM" },
  { name: "Moldova, Republic of", code: "MD" },
  { name: "Monaco", code: "MC" },
  { name: "Mongolia", code: "MN" },
  { name: "Montenegro", code: "ME" },
  { name: "Montserrat", code: "MS" },
  { name: "Morocco", code: "MA" },
  { name: "Mozambique", code: "MZ" },
  { name: "Myanmar", code: "MM" },
  { name: "Namibia", code: "NA" },
  { name: "Nauru", code: "NR" },
  { name: "Nepal", code: "NP" },
  { name: "Netherlands", code: "NL" },
  { name: "Netherlands Antilles", code: "AN" },
  { name: "New Caledonia", code: "NC" },
  { name: "New Zealand", code: "NZ" },
  { name: "Nicaragua", code: "NI" },
  { name: "Niger", code: "NE" },
  { name: "Nigeria", code: "NG" },
  { name: "Niue", code: "NU" },
  { name: "Norfolk Island", code: "NF" },
  { name: "Northern Mariana Islands", code: "MP" },
  { name: "Norway", code: "NO" },
  { name: "Oman", code: "OM" },
  { name: "Pakistan", code: "PK" },
  { name: "Palau", code: "PW" },
  { name: "Palestinian Territory, Occupied", code: "PS" },
  { name: "Panama", code: "PA" },
  { name: "Papua New Guinea", code: "PG" },
  { name: "Paraguay", code: "PY" },
  { name: "Peru", code: "PE" },
  { name: "Philippines", code: "PH" },
  { name: "Pitcairn", code: "PN" },
  { name: "Poland", code: "PL" },
  { name: "Portugal", code: "PT" },
  { name: "Puerto Rico", code: "PR" },
  { name: "Qatar", code: "QA" },
  { name: "Reunion", code: "RE" },
  { name: "Romania", code: "RO" },
  { name: "Russian Federation", code: "RU" },
  { name: "RWANDA", code: "RW" },
  { name: "Saint Helena", code: "SH" },
  { name: "Saint Kitts and Nevis", code: "KN" },
  { name: "Saint Lucia", code: "LC" },
  { name: "Saint Pierre and Miquelon", code: "PM" },
  { name: "Saint Vincent and the Grenadines", code: "VC" },
  { name: "Samoa", code: "WS" },
  { name: "San Marino", code: "SM" },
  { name: "Sao Tome and Principe", code: "ST" },
  { name: "Saudi Arabia", code: "SA" },
  { name: "Senegal", code: "SN" },
  { name: "Serbia", code: "RS" },
  { name: "Seychelles", code: "SC" },
  { name: "Sierra Leone", code: "SL" },
  { name: "Singapore", code: "SG" },
  { name: "Slovakia", code: "SK" },
  { name: "Slovenia", code: "SI" },
  { name: "Solomon Islands", code: "SB" },
  { name: "Somalia", code: "SO" },
  { name: "South Africa", code: "ZA" },
  { name: "South Georgia and the South Sandwich Islands", code: "GS" },
  { name: "Spain", code: "ES" },
  { name: "Sri Lanka", code: "LK" },
  { name: "Sudan", code: "SD" },
  { name: "Suriname", code: "SR" },
  { name: "Svalbard and Jan Mayen", code: "SJ" },
  { name: "Swaziland", code: "SZ" },
  { name: "Sweden", code: "SE" },
  { name: "Switzerland", code: "CH" },
  { name: "Syrian Arab Republic", code: "SY" },
  { name: "Taiwan, Province of China", code: "TW" },
  { name: "Tajikistan", code: "TJ" },
  { name: "Tanzania, United Republic of", code: "TZ" },
  { name: "Thailand", code: "TH" },
  { name: "Timor-Leste", code: "TL" },
  { name: "Togo", code: "TG" },
  { name: "Tokelau", code: "TK" },
  { name: "Tonga", code: "TO" },
  { name: "Trinidad and Tobago", code: "TT" },
  { name: "Tunisia", code: "TN" },
  { name: "Turkey", code: "TR" },
  { name: "Turkmenistan", code: "TM" },
  { name: "Turks and Caicos Islands", code: "TC" },
  { name: "Tuvalu", code: "TV" },
  { name: "Uganda", code: "UG" },
  { name: "Ukraine", code: "UA" },
  { name: "United Arab Emirates", code: "AE" },
  { name: "United Kingdom", code: "GB" },
  { name: "United States", code: "US" },
  { name: "United States Minor Outlying Islands", code: "UM" },
  { name: "Uruguay", code: "UY" },
  { name: "Uzbekistan", code: "UZ" },
  { name: "Vanuatu", code: "VU" },
  { name: "Venezuela", code: "VE" },
  { name: "Viet Nam", code: "VN" },
  { name: "Virgin Islands, British", code: "VG" },
  { name: "Virgin Islands, U.S.", code: "VI" },
  { name: "Wallis and Futuna", code: "WF" },
  { name: "Western Sahara", code: "EH" },
  { name: "Yemen", code: "YE" },
  { name: "Zambia", code: "ZM" },
  { name: "Zimbabwe", code: "ZW" }
], q = (a) => v.find((e) => e.code === a), X = [
  {
    label: "Afar",
    alpha2: "aa",
    alpha3: "aar"
  },
  {
    label: "Abkhazian",
    alpha2: "ab",
    alpha3: "abk"
  },
  {
    label: "Afrikaans",
    alpha2: "af",
    alpha3: "afr"
  },
  {
    label: "Akan",
    alpha2: "ak",
    alpha3: "aka"
  },
  {
    label: "Albanian",
    alpha2: "sq",
    alpha3: "alb"
  },
  {
    label: "Amharic",
    alpha2: "am",
    alpha3: "amh"
  },
  {
    label: "Arabic",
    alpha2: "ar",
    alpha3: "ara"
  },
  {
    label: "Aragonese",
    alpha2: "an",
    alpha3: "arg"
  },
  {
    label: "Armenian",
    alpha2: "hy",
    alpha3: "arm"
  },
  {
    label: "Assamese",
    alpha2: "as",
    alpha3: "asm"
  },
  {
    label: "Avaric",
    alpha2: "av",
    alpha3: "ava"
  },
  {
    label: "Avestan",
    alpha2: "ae",
    alpha3: "ave"
  },
  {
    label: "Aymara",
    alpha2: "ay",
    alpha3: "aym"
  },
  {
    label: "Azerbaijani",
    alpha2: "az",
    alpha3: "aze"
  },
  {
    label: "Bashkir",
    alpha2: "ba",
    alpha3: "bak"
  },
  {
    label: "Bambara",
    alpha2: "bm",
    alpha3: "bam"
  },
  {
    label: "Basque",
    alpha2: "eu",
    alpha3: "baq"
  },
  {
    label: "Belarusian",
    alpha2: "be",
    alpha3: "bel"
  },
  {
    label: "Bengali",
    alpha2: "bn",
    alpha3: "ben"
  },
  {
    label: "Bihari languages",
    alpha2: "bh",
    alpha3: "bih"
  },
  {
    label: "Bislama",
    alpha2: "bi",
    alpha3: "bis"
  },
  {
    label: "Bosnian",
    alpha2: "bs",
    alpha3: "bos"
  },
  {
    label: "Breton",
    alpha2: "br",
    alpha3: "bre"
  },
  {
    label: "Bulgarian",
    alpha2: "bg",
    alpha3: "bul"
  },
  {
    label: "Burmese",
    alpha2: "my",
    alpha3: "bur"
  },
  {
    label: "Catalan; Valencian",
    alpha2: "ca",
    alpha3: "cat"
  },
  {
    label: "Chamorro",
    alpha2: "ch",
    alpha3: "cha"
  },
  {
    label: "Chechen",
    alpha2: "ce",
    alpha3: "che"
  },
  {
    label: "Chinese",
    alpha2: "zh",
    alpha3: "chi"
  },
  {
    label: "Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic",
    alpha2: "cu",
    alpha3: "chu"
  },
  {
    label: "Chuvash",
    alpha2: "cv",
    alpha3: "chv"
  },
  {
    label: "Cornish",
    alpha2: "kw",
    alpha3: "cor"
  },
  {
    label: "Corsican",
    alpha2: "co",
    alpha3: "cos"
  },
  {
    label: "Cree",
    alpha2: "cr",
    alpha3: "cre"
  },
  {
    label: "Czech",
    alpha2: "cs",
    alpha3: "cze"
  },
  {
    label: "Danish",
    alpha2: "da",
    alpha3: "dan"
  },
  {
    label: "Divehi; Dhivehi; Maldivian",
    alpha2: "dv",
    alpha3: "div"
  },
  {
    label: "Dutch; Flemish",
    alpha2: "nl",
    alpha3: "dut"
  },
  {
    label: "Dzongkha",
    alpha2: "dz",
    alpha3: "dzo"
  },
  {
    label: "English",
    alpha2: "en",
    alpha3: "eng"
  },
  {
    label: "Esperanto",
    alpha2: "eo",
    alpha3: "epo"
  },
  {
    label: "Estonian",
    alpha2: "et",
    alpha3: "est"
  },
  {
    label: "Ewe",
    alpha2: "ee",
    alpha3: "ewe"
  },
  {
    label: "Faroese",
    alpha2: "fo",
    alpha3: "fao"
  },
  {
    label: "Fijian",
    alpha2: "fj",
    alpha3: "fij"
  },
  {
    label: "Finnish",
    alpha2: "fi",
    alpha3: "fin"
  },
  {
    label: "French",
    alpha2: "fr",
    alpha3: "fre"
  },
  {
    label: "Western Frisian",
    alpha2: "fy",
    alpha3: "fry"
  },
  {
    label: "Fulah",
    alpha2: "ff",
    alpha3: "ful"
  },
  {
    label: "Georgian",
    alpha2: "ka",
    alpha3: "geo"
  },
  {
    label: "German",
    alpha2: "de",
    alpha3: "ger"
  },
  {
    label: "Gaelic; Scottish Gaelic",
    alpha2: "gd",
    alpha3: "gla"
  },
  {
    label: "Irish",
    alpha2: "ga",
    alpha3: "gle"
  },
  {
    label: "Galician",
    alpha2: "gl",
    alpha3: "glg"
  },
  {
    label: "Manx",
    alpha2: "gv",
    alpha3: "glv"
  },
  {
    label: "Greek, Modern (1453-)",
    alpha2: "el",
    alpha3: "gre"
  },
  {
    label: "Guarani",
    alpha2: "gn",
    alpha3: "grn"
  },
  {
    label: "Gujarati",
    alpha2: "gu",
    alpha3: "guj"
  },
  {
    label: "Haitian; Haitian Creole",
    alpha2: "ht",
    alpha3: "hat"
  },
  {
    label: "Hausa",
    alpha2: "ha",
    alpha3: "hau"
  },
  {
    label: "Hebrew",
    alpha2: "he",
    alpha3: "heb"
  },
  {
    label: "Herero",
    alpha2: "hz",
    alpha3: "her"
  },
  {
    label: "Hindi",
    alpha2: "hi",
    alpha3: "hin"
  },
  {
    label: "Hiri Motu",
    alpha2: "ho",
    alpha3: "hmo"
  },
  {
    label: "Croatian",
    alpha2: "hr",
    alpha3: "hrv"
  },
  {
    label: "Hungarian",
    alpha2: "hu",
    alpha3: "hun"
  },
  {
    label: "Igbo",
    alpha2: "ig",
    alpha3: "ibo"
  },
  {
    label: "Icelandic",
    alpha2: "is",
    alpha3: "ice"
  },
  {
    label: "Ido",
    alpha2: "io",
    alpha3: "ido"
  },
  {
    label: "Sichuan Yi; Nuosu",
    alpha2: "ii",
    alpha3: "iii"
  },
  {
    label: "Inuktitut",
    alpha2: "iu",
    alpha3: "iku"
  },
  {
    label: "Interlingue; Occidental",
    alpha2: "ie",
    alpha3: "ile"
  },
  {
    label: "Interlingua (International Auxiliary Language Association)",
    alpha2: "ia",
    alpha3: "ina"
  },
  {
    label: "Indonesian",
    alpha2: "id",
    alpha3: "ind"
  },
  {
    label: "Inupiaq",
    alpha2: "ik",
    alpha3: "ipk"
  },
  {
    label: "Italian",
    alpha2: "it",
    alpha3: "ita"
  },
  {
    label: "Javanese",
    alpha2: "jv",
    alpha3: "jav"
  },
  {
    label: "Japanese",
    alpha2: "ja",
    alpha3: "jpn"
  },
  {
    label: "Kalaallisut; Greenlandic",
    alpha2: "kl",
    alpha3: "kal"
  },
  {
    label: "Kannada",
    alpha2: "kn",
    alpha3: "kan"
  },
  {
    label: "Kashmiri",
    alpha2: "ks",
    alpha3: "kas"
  },
  {
    label: "Kanuri",
    alpha2: "kr",
    alpha3: "kau"
  },
  {
    label: "Kazakh",
    alpha2: "kk",
    alpha3: "kaz"
  },
  {
    label: "Central Khmer",
    alpha2: "km",
    alpha3: "khm"
  },
  {
    label: "Kikuyu; Gikuyu",
    alpha2: "ki",
    alpha3: "kik"
  },
  {
    label: "Kinyarwanda",
    alpha2: "rw",
    alpha3: "kin"
  },
  {
    label: "Kirghiz; Kyrgyz",
    alpha2: "ky",
    alpha3: "kir"
  },
  {
    label: "Komi",
    alpha2: "kv",
    alpha3: "kom"
  },
  {
    label: "Kongo",
    alpha2: "kg",
    alpha3: "kon"
  },
  {
    label: "Korean",
    alpha2: "ko",
    alpha3: "kor"
  },
  {
    label: "Kuanyama; Kwanyama",
    alpha2: "kj",
    alpha3: "kua"
  },
  {
    label: "Kurdish",
    alpha2: "ku",
    alpha3: "kur"
  },
  {
    label: "Lao",
    alpha2: "lo",
    alpha3: "lao"
  },
  {
    label: "Latin",
    alpha2: "la",
    alpha3: "lat"
  },
  {
    label: "Latvian",
    alpha2: "lv",
    alpha3: "lav"
  },
  {
    label: "Limburgan; Limburger; Limburgish",
    alpha2: "li",
    alpha3: "lim"
  },
  {
    label: "Lingala",
    alpha2: "ln",
    alpha3: "lin"
  },
  {
    label: "Lithuanian",
    alpha2: "lt",
    alpha3: "lit"
  },
  {
    label: "Luxembourgish; Letzeburgesch",
    alpha2: "lb",
    alpha3: "ltz"
  },
  {
    label: "Luba-Katanga",
    alpha2: "lu",
    alpha3: "lub"
  },
  {
    label: "Ganda",
    alpha2: "lg",
    alpha3: "lug"
  },
  {
    label: "Macedonian",
    alpha2: "mk",
    alpha3: "mac"
  },
  {
    label: "Marshallese",
    alpha2: "mh",
    alpha3: "mah"
  },
  {
    label: "Malayalam",
    alpha2: "ml",
    alpha3: "mal"
  },
  {
    label: "Maori",
    alpha2: "mi",
    alpha3: "mao"
  },
  {
    label: "Marathi",
    alpha2: "mr",
    alpha3: "mar"
  },
  {
    label: "Malay",
    alpha2: "ms",
    alpha3: "may"
  },
  {
    label: "Malagasy",
    alpha2: "mg",
    alpha3: "mlg"
  },
  {
    label: "Maltese",
    alpha2: "mt",
    alpha3: "mlt"
  },
  {
    label: "Mongolian",
    alpha2: "mn",
    alpha3: "mon"
  },
  {
    label: "Nauru",
    alpha2: "na",
    alpha3: "nau"
  },
  {
    label: "Navajo; Navaho",
    alpha2: "nv",
    alpha3: "nav"
  },
  {
    label: "Ndebele, South; South Ndebele",
    alpha2: "nr",
    alpha3: "nbl"
  },
  {
    label: "Ndebele, North; North Ndebele",
    alpha2: "nd",
    alpha3: "nde"
  },
  {
    label: "Ndonga",
    alpha2: "ng",
    alpha3: "ndo"
  },
  {
    label: "Nepali",
    alpha2: "ne",
    alpha3: "nep"
  },
  {
    label: "Norwegian Nynorsk; Nynorsk, Norwegian",
    alpha2: "nn",
    alpha3: "nno"
  },
  {
    label: "Bokmål, Norwegian; Norwegian Bokmål",
    alpha2: "nb",
    alpha3: "nob"
  },
  {
    label: "Norwegian",
    alpha2: "no",
    alpha3: "nor"
  },
  {
    label: "Chichewa; Chewa; Nyanja",
    alpha2: "ny",
    alpha3: "nya"
  },
  {
    label: "Occitan (post 1500)",
    alpha2: "oc",
    alpha3: "oci"
  },
  {
    label: "Ojibwa",
    alpha2: "oj",
    alpha3: "oji"
  },
  {
    label: "Oriya",
    alpha2: "or",
    alpha3: "ori"
  },
  {
    label: "Oromo",
    alpha2: "om",
    alpha3: "orm"
  },
  {
    label: "Ossetian; Ossetic",
    alpha2: "os",
    alpha3: "oss"
  },
  {
    label: "Panjabi; Punjabi",
    alpha2: "pa",
    alpha3: "pan"
  },
  {
    label: "Persian",
    alpha2: "fa",
    alpha3: "per"
  },
  {
    label: "Pali",
    alpha2: "pi",
    alpha3: "pli"
  },
  {
    label: "Polish",
    alpha2: "pl",
    alpha3: "pol"
  },
  {
    label: "Portuguese",
    alpha2: "pt",
    alpha3: "por"
  },
  {
    label: "Pushto; Pashto",
    alpha2: "ps",
    alpha3: "pus"
  },
  {
    label: "Quechua",
    alpha2: "qu",
    alpha3: "que"
  },
  {
    label: "Romansh",
    alpha2: "rm",
    alpha3: "roh"
  },
  {
    label: "Romanian; Moldavian; Moldovan",
    alpha2: "ro",
    alpha3: "rum"
  },
  {
    label: "Rundi",
    alpha2: "rn",
    alpha3: "run"
  },
  {
    label: "Russian",
    alpha2: "ru",
    alpha3: "rus"
  },
  {
    label: "Sango",
    alpha2: "sg",
    alpha3: "sag"
  },
  {
    label: "Sanskrit",
    alpha2: "sa",
    alpha3: "san"
  },
  {
    label: "Sinhala; Sinhalese",
    alpha2: "si",
    alpha3: "sin"
  },
  {
    label: "Slovak",
    alpha2: "sk",
    alpha3: "slo"
  },
  {
    label: "Slovenian",
    alpha2: "sl",
    alpha3: "slv"
  },
  {
    label: "Northern Sami",
    alpha2: "se",
    alpha3: "sme"
  },
  {
    label: "Samoan",
    alpha2: "sm",
    alpha3: "smo"
  },
  {
    label: "Shona",
    alpha2: "sn",
    alpha3: "sna"
  },
  {
    label: "Sindhi",
    alpha2: "sd",
    alpha3: "snd"
  },
  {
    label: "Somali",
    alpha2: "so",
    alpha3: "som"
  },
  {
    label: "Sotho, Southern",
    alpha2: "st",
    alpha3: "sot"
  },
  {
    label: "Spanish; Castilian",
    alpha2: "es",
    alpha3: "spa"
  },
  {
    label: "Sardinian",
    alpha2: "sc",
    alpha3: "srd"
  },
  {
    label: "Serbian",
    alpha2: "sr",
    alpha3: "srp"
  },
  {
    label: "Swati",
    alpha2: "ss",
    alpha3: "ssw"
  },
  {
    label: "Sundanese",
    alpha2: "su",
    alpha3: "sun"
  },
  {
    label: "Swahili",
    alpha2: "sw",
    alpha3: "swa"
  },
  {
    label: "Swedish",
    alpha2: "sv",
    alpha3: "swe"
  },
  {
    label: "Tahitian",
    alpha2: "ty",
    alpha3: "tah"
  },
  {
    label: "Tamil",
    alpha2: "ta",
    alpha3: "tam"
  },
  {
    label: "Tatar",
    alpha2: "tt",
    alpha3: "tat"
  },
  {
    label: "Telugu",
    alpha2: "te",
    alpha3: "tel"
  },
  {
    label: "Tajik",
    alpha2: "tg",
    alpha3: "tgk"
  },
  {
    label: "Tagalog",
    alpha2: "tl",
    alpha3: "tgl"
  },
  {
    label: "Thai",
    alpha2: "th",
    alpha3: "tha"
  },
  {
    label: "Tibetan",
    alpha2: "bo",
    alpha3: "tib"
  },
  {
    label: "Tigrinya",
    alpha2: "ti",
    alpha3: "tir"
  },
  {
    label: "Tonga (Tonga Islands)",
    alpha2: "to",
    alpha3: "ton"
  },
  {
    label: "Tswana",
    alpha2: "tn",
    alpha3: "tsn"
  },
  {
    label: "Tsonga",
    alpha2: "ts",
    alpha3: "tso"
  },
  {
    label: "Turkmen",
    alpha2: "tk",
    alpha3: "tuk"
  },
  {
    label: "Turkish",
    alpha2: "tr",
    alpha3: "tur"
  },
  {
    label: "Twi",
    alpha2: "tw",
    alpha3: "twi"
  },
  {
    label: "Uighur; Uyghur",
    alpha2: "ug",
    alpha3: "uig"
  },
  {
    label: "Ukrainian",
    alpha2: "uk",
    alpha3: "ukr"
  },
  {
    label: "Urdu",
    alpha2: "ur",
    alpha3: "urd"
  },
  {
    label: "Uzbek",
    alpha2: "uz",
    alpha3: "uzb"
  },
  {
    label: "Venda",
    alpha2: "ve",
    alpha3: "ven"
  },
  {
    label: "Vietnamese",
    alpha2: "vi",
    alpha3: "vie"
  },
  {
    label: "Volapük",
    alpha2: "vo",
    alpha3: "vol"
  },
  {
    label: "Welsh",
    alpha2: "cy",
    alpha3: "wel"
  },
  {
    label: "Walloon",
    alpha2: "wa",
    alpha3: "wln"
  },
  {
    label: "Wolof",
    alpha2: "wo",
    alpha3: "wol"
  },
  {
    label: "Xhosa",
    alpha2: "xh",
    alpha3: "xho"
  },
  {
    label: "Yiddish",
    alpha2: "yi",
    alpha3: "yid"
  },
  {
    label: "Yoruba",
    alpha2: "yo",
    alpha3: "yor"
  },
  {
    label: "Zhuang; Chuang",
    alpha2: "za",
    alpha3: "zha"
  },
  {
    label: "Zulu",
    alpha2: "zu",
    alpha3: "zul"
  }
], Q = ({
  price: a,
  productUuid: e,
  type: l
}) => a && e ? {
  uuid: e,
  amount: a.netPrice || a.amount,
  currency: a.currency,
  type: l
} : void 0, f = [
  "google.com",
  "twitter.com",
  "facebook.com",
  "apple.com"
], $ = (a) => !!a && f.includes(a);
var y = /* @__PURE__ */ ((a) => (a.FACEBOOK = "FACEBOOK", a.TWITTER = "TWITTER", a.GOOGLE = "GOOGLE", a.APPLE = "APPLE", a))(y || {});
const aa = (a) => {
  switch (a) {
    case "google.com":
      return "GOOGLE";
    case "twitter.com":
      return "TWITTER";
    case "facebook.com":
      return "FACEBOOK";
    case "apple.com":
      return "APPLE";
    default:
      return "";
  }
};
export {
  na as AssetAccessType,
  c as AssetType,
  T as AuthenticationProvider,
  u as BillingAddressValue,
  b as BillingNameValue,
  oa as ComponentType,
  ha as ContentType,
  g as ContinueWatchingEvent,
  ca as CouponType,
  ia as Currency,
  ra as DataType,
  sa as DiscountType,
  pa as EXTERNAL_PAYMENT_PROVIDERS,
  da as EventContext,
  ta as FrameType,
  S as GetAssetTokenType,
  A as ImageType,
  ma as IntervalType,
  ba as MOBILE_PLAYER_MAX_TITLE_LENGTH,
  ua as NO_PREFERENCE,
  _ as PageComponentType,
  Aa as PaymentGateway,
  R as PaymentProvider,
  Ea as Period,
  I as PlaybackValidationErrorCode,
  Sa as PromotionType,
  p as Resolution,
  f as SOCIAL_AUTH_PROVIDERS_IDS,
  Ta as SSO_AUTH_PROVIDERS,
  H as STREAM_CONCURRENCY_ERROR_CODE,
  Ra as SchemaVersion,
  y as SocialAuthenticationProviders,
  L as StreamError,
  ga as TIME_BREAK_TILL_LAST_MOMENT,
  _a as TIME_BREAK_TILL_VIDEO_END,
  N as TaxProductTypes,
  Na as TrackEvent,
  E as VideoType,
  Ia as Watchable,
  za as adCountdown,
  La as appDefaultColors,
  fa as calculateWatchingPercent,
  Z as checkExcludedSentryErrors,
  Oa as checkIfOneTimeEvent,
  v as countries,
  B as defaultDetailsPath,
  Ca as excludeUserContext,
  ya as formatDuration,
  Y as generateProfileColor,
  j as generateProfileInitials,
  Ma as getAssetContentWithType,
  V as getAssetDetailsPath,
  Pa as getAssetImageWithType,
  ka as getAssetRootImageWithType,
  q as getCountryByCode,
  J as getHighestAvailableResolutionOnPlan,
  Wa as getInitialPlaylistStartTime,
  xa as getNextPlaylistItem,
  aa as getSocialProviderName,
  Ya as hasAds,
  ja as hasPreRollAds,
  Va as isAdPlaylist,
  Ga as isAssetWatchable,
  Za as isPlayingAd,
  $ as isUserLoggedBySocials,
  X as languages,
  D as livePath,
  Da as mapAssetsForItemsPresentedEvent,
  Q as mapTaxProduct,
  k as moviePath,
  Ka as parseText,
  x as planDetailsHTMLAttributesToRender,
  W as planDetailsHTMLTagsToRender,
  z as primaryColor,
  F as retry,
  Ba as setThemeColors,
  G as showPath,
  wa as sortByOrder,
  Ua as trackerSchema,
  M as transformAssetName,
  P as transformAssetNameRegex,
  Ha as useTransformedText
};
//# sourceMappingURL=core.js.map
